import Vue from 'vue';
import Router from 'vue-router';

import NetworkError from '../pages/NetworkError/NetworkError';
import PageNotFound from '../pages/404/404.vue';
import OpenApp from '../pages/OpenApp/OpenApp.vue';

import adminRoutes from './routes/admin';
import publicRoutes from './routes/public';
import employeeRoutes from './routes/employee';
import candidateRoutes from './routes/candidate';
import JobOfferWid from '../pages/jobOfferWid/JobOfferWid.vue'
import ManagementCand from '../pages/ManagementCand/ManagementCand.vue'
import RelanceCandidature from '../pages/RelanceCandidature/RelanceCandidature.vue'
Vue.use(Router);

const router = new Router({
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  mode: 'history',
  routes: [
    {
      path: '/', // Un ADV connecté peut visualiser la page d'accueil
      redirect: { name: 'home', params: { company: 'default' } },
    },
    {

      path: '/public/ma-candidature',
      component: ManagementCand,

     },
    {

      path: '/public/relance-candidature',
      component: RelanceCandidature,

     },
    publicRoutes,
    adminRoutes,
    employeeRoutes,
    candidateRoutes,
    {
    
      path: '/job-offer/:wid',
      component: JobOfferWid,
  
   }, 
 
    {
      path: '/erreur-reseau',
      component: NetworkError,
      name: 'NetworkErrorPage',
    },
    // 404 Page
    {
      path: '/pas-trouvé',
      component: PageNotFound,
      name: '404ErrorPageNotFound',
    },
    {
      path: '*',
      redirect: '/pas-trouvé'
    }, 
    // Deep link
    {
      path: '/open-app',
      component: OpenApp,
      name: 'OpenApp',
    },
  ],
});

export default router
